import { Icon } from "antd";
import _ from "lodash";
import moment from "moment";
import React, { Component } from "react";
import { connect } from "react-redux";
import ScrollWrapper from "../../../../common/components/ScrollBar";
import { getLocal } from "../../../../helpers/Local";
import {
  getDetailUltrasounds,
  get_cpt_code_review,
  get_ultrasound_type,
  setSidebarState,
  ultrasoundReviewLoadInit,
  updateAppointmentFinalizedDate,
} from "../../../../store/actions";
import ReviewSidebar from "./ReviewSidebar";
import ReviewText from "./ReviewText";

class Review extends Component {
  sidebarRef = null;
  constructor(props) {
    super(props);
    this.sidebarRef = React.createRef();
  }

  state = {
    isSidebar: false,
    nameUltrasound: null,
    nameSignal: null,
    valueText: "",
    dataCPT: [],
    finalizedDate: moment().format("MM/DD/YYYY hh:mm:ss A"),
    finalizedDateDate: moment().format("MM/DD/YYYY"),
    providerId: 0,
    providerName: "",
  };

  componentDidMount() {
    const appointment_ultrasound_id = getLocal("appointment_ultrasound_id");
    const current_ultrasound_id = getLocal("current_ultrasound_id");
    this.props.ultrasoundReviewLoadInit(appointment_ultrasound_id);
    this.props.get_cpt_code_review(appointment_ultrasound_id);
    this.props.get_ultrasound_type(current_ultrasound_id);
    this.props.getDetailUltrasounds(current_ultrasound_id);
    this.props.setSidebarState(true);
    this.setState({ isSidebar: window.innerWidth <= 768 ? false : true });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps?.CPT?.finalized_date) {
      this.setState({
        finalizedDate: moment(nextProps?.CPT?.finalized_date).format("MM/DD/YYYY hh:mm:ss A"),
        finalizedDateDate: moment(nextProps?.CPT?.finalized_date).format("MM/DD/YYYY"),
      });
    }
    const current_provider_id = getLocal("cvai-current-user-provider-id");
    const current_provider_name = getLocal("cvai-current-user-provider-name");
    //if current logged in provider == provider on the app
    if (current_provider_name && current_provider_id && parseInt(current_provider_id) != 110) {
      if (nextProps.only_providers) {
        let provider = _.find(nextProps.only_providers, { id: 110 });
        if (provider) {
          this.setState({ providerId: provider.id });
          this.setState({ providerName: provider.value });
        }
      }
    } else {
      if (nextProps?.CPT?.reading_physician_id) {
        this.setState({ providerId: nextProps?.CPT?.reading_physician_id });
        if (nextProps.only_providers) {
          let provider = _.find(nextProps.only_providers, { id: nextProps?.CPT?.reading_physician_id });
          if (provider) {
            this.setState({ providerName: provider.value });
          }
        }
      }
    }
  }

  componentWillUnmount() {
    this.props.setSidebarState(false);
  }

  handleSidebar = () => {
    this.setState({ isSidebar: true });
  };

  toggleSidebar = () => {
    this.setState({ isSidebar: !this.state.isSidebar });
  };

  handleCloseSidebar = () => {
    this.setState({ isSidebar: false });
    this.props.setSidebarState(false);
  };

  handleEditable = (status) => {
    this.setState({ isEditable: status });
  };

  handleContent = (e) => {
    this.setState({ content: e.target?.value });
  };

  handleSubmit = () => {
    this.setState({ isEditable: false, content: this.state.editedContent });
  };

  cancleEditable = () => {
    this.setState({ isEditable: false });
  };

  changeValueText = (value) => {
    this.setState({ valueText: value });
  };

  onChangeCPT = (value) => {
    this.setState({ dataCPT: value });
  };

  handleChangeTime = (value) => {
    const appointment_ultrasound_id = getLocal("appointment_ultrasound_id");
    this.setState({
      finalizedDate: moment(value).format("MM/DD/YYYY hh:mm:ss A"),
    });
    this.props.updateAppointmentFinalizedDate(appointment_ultrasound_id, {
      finalized_date: moment(value).format("YYYY-MM-DD HH:mm:ss"),
    });
    this.setState({ finalizedDateDate: moment(value).format("MM/DD/YYYY") });
  };

  handleChangeProvider = (value) => {
    this.setState({
      providerId: value,
    });
    if (this.props.providers.length > 0) {
      let found_provider = _.find(this.props.providers, function (provider) {
        return provider.id === value;
      });
      if (found_provider) {
        this.setState({
          providerName: found_provider.value,
        });
      }
    }
  };

  render() {
    const { isSidebar, valueText, dataCPT, nameUltrasound } = this.state;
    return (
      <div className="clinicWorkflow__main-section">
        <div className="eventsContainer has-sub-header" style={{ paddingTop: "1rem" }}>
          <ScrollWrapper css="conditionList">
            <ReviewText
              nameUltrasound={nameUltrasound}
              dataCPT={dataCPT}
              nameSignal={this.state.nameSignal}
              changeValueText={(value) => {
                this.changeValueText(value);
              }}
              finalizedDate={this.state.finalizedDate}
              finalizedDateDate={this.state.finalizedDateDate}
              providerId={this.state.providerId}
              providerName={this.state.providerName}
            />
          </ScrollWrapper>
        </div>
        <ReviewSidebar
          ref={this.sidebarRef}
          onChangeCPT={(value) => {
            this.onChangeCPT(value);
          }}
          setNameSignal={(value) => {
            this.setState({
              nameSignal: value,
            });
          }}
          setNameUltrasound={(value) => {
            this.setState({ nameUltrasound: value });
          }}
          sidebarIcon={<Icon type="funnel-plot" theme="twoTone" twoToneColor="#740937" />}
          valueText={valueText}
          isShow={isSidebar}
          handleCloseSidebar={this.handleCloseSidebar}
          handleChangeTime={this.handleChangeTime}
          handleChangeProvider={this.handleChangeProvider}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  CPT: state.common.CPT,
  only_providers: state.common.only_providers,
  providers: state.common.only_providers,
});

const mapDispatchToProps = {
  ultrasoundReviewLoadInit,
  get_cpt_code_review,
  get_ultrasound_type,
  getDetailUltrasounds,
  setSidebarState,
  updateAppointmentFinalizedDate,
};

export default connect(mapStateToProps, mapDispatchToProps)(Review);
